import React, { useState } from "react";
import { getCountryFlag } from "@/lib/countries";

export function emojiToIsoCode(emoji: string): string | null {
  if (!emoji || emoji.length < 4) return null;
  const cp1 = emoji.codePointAt(0);
  const cp2 = emoji.codePointAt(2);
  if (cp1 && cp2 && cp1 >= 0x1f1e6 && cp1 <= 0x1f1ff && cp2 >= 0x1f1e6 && cp2 <= 0x1f1ff) {
    const char1 = String.fromCharCode(65 + cp1 - 0x1f1e6);
    const char2 = String.fromCharCode(65 + cp2 - 0x1f1e6);
    return (char1 + char2).toLowerCase();
  }
  return null;
}

interface CountryFlagProps {
  country?: string | number | null;
  countryNameFallback?: string;
  flagEmoji?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function CountryFlag({
  country,
  countryNameFallback,
  flagEmoji,
  className = "",
  size = "md",
}: CountryFlagProps) {
  const [error, setError] = useState(false);
  const emoji = flagEmoji || getCountryFlag(country, countryNameFallback);
  const iso = emojiToIsoCode(emoji);

  const sizeClasses = {
    sm: "h-3 w-4 min-w-[16px]",
    md: "h-4 w-5 min-w-[20px]",
    lg: "h-5 w-7 min-w-[28px]",
  };

  if (!iso || error || emoji === "🌐") {
    return (
      <span
        className={`inline-flex items-center justify-center font-emoji leading-none ${className}`}
      >
        {emoji}
      </span>
    );
  }

  return (
    <img
      src={`https://flagcdn.com/w40/${iso}.png`}
      alt={iso.toUpperCase()}
      onError={() => setError(true)}
      className={`inline-block object-cover rounded-[2px] shadow-xs border border-white/10 ${sizeClasses[size]} ${className}`}
      loading="lazy"
    />
  );
}
